<app-card [showHeader]="false">
    <ng-template #content>
        <div class="flex flex-column gap-3 p-2 message-detail">

            @let r = recipient();
            @let m = r?.message;

            <div class="grid-2col input-grid-gaps">
                <div class="field">
                    <div class="textLabel">{{ prefix + 'fields.createdAt' | translate }}</div>
                    <div>{{ m?.createdAt | localDate: 'medium' }}</div>
                </div>
                <div class="field">
                    <div class="textLabel">{{ prefix + 'fields.validFrom' | translate }}</div>
                    <div>{{ m?.validFrom | shortDate }}</div>
                </div>
                @if (m?.validTo) {
                    <div class="field">
                        <div class="textLabel">{{ prefix + 'fields.validTo' | translate }}</div>
                        <div>{{ m?.validTo | shortDate }}</div>
                    </div>
                }
                @if (m?.category) {
                    <div class="field">
                        <div class="textLabel">{{ prefix + 'fields.category' | translate }}</div>
                        <div>{{ ('enum.messageCategory.' + m.category) | translate }}</div>
                    </div>
                }
            </div>

            <div class="field">
                <div class="textLabel">{{ prefix + 'fields.title' | translate }}</div>
                <div class="textBody">{{ m?.title }}</div>
            </div>

            <div class="field">
                <div class="textLabel">{{ prefix + 'fields.content' | translate }}</div>
                <div class="textBody message-content" [innerHTML]="m?.content || ''"></div>
            </div>

            @if (files().length) {
                <div class="field">
                    <div class="textLabel">{{ prefix + 'fields.files' | translate }}</div>
                    <div class="flex flex-column gap-1 message-files">
                        @for (link of files(); track link.fileId) {
                            <app-file-link-component [file]="link"></app-file-link-component>
                        }
                    </div>
                </div>
            }

            <div class="flex justify-content-end pt-2">
                <app-button
                    icon="pi-check"
                    [label]="prefix + (isRead() ? 'alreadyRead' : 'confirmRead') | translate"
                    [disabled]="isRead() || saving()"
                    (clickEvent)="confirmRead()"
                ></app-button>
            </div>

        </div>
    </ng-template>
</app-card>
